import { useAlert } from '@rahtab/ui';
import { useNavigation, NavigationProp } from '@react-navigation/native';
import { useState } from 'react';
import { unhandledErrorGenerator, useRequest } from '@rahtab/auth/lib/token-based-auth';
import { RootStackType } from '../../Router';

export const useSendMessage = () => {
  const [loading, setLoading] = useState(false);
  const request = useRequest();
  const { navigate } = useNavigation<NavigationProp<RootStackType>>();
  const alert = useAlert();
  const sendMessage = async ({ title, text }: { title: string; text: string }) => {
    setLoading(true);
    try {
      const message = await request<boolean>('SendMessageToSupport', {
        params: `MessageTitle=${title}&MessageText=${text}`,
      });
      if (message === true) {
        setLoading(false);
        alert({
          message: 'پیام با موفقیت ارسال شد.',
          hideBackButton: true,
          buttons: [
            {
              text: 'بازگشت',
              onPress: () => navigate('Support', { refetch: true }),
            },
          ],
        });
      } else if (message === false) {
        setLoading(false);
        alert({ title: 'خطا', message: 'ثبت پیام شما با خطا رو به رو شد، لطفا دوباره تلاش کنید.' });
      } else if (typeof message !== 'boolean') {
        setLoading(false);
        alert(unhandledErrorGenerator(506));
      }
    } catch (er) {
      setLoading(false);
    }
  };
  return { loading, sendMessage };
};
